import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { IOrderLifetimeRule } from './orderLifetimeRule.interface';

export namespace OrderLifetimeRuleAction {
  const actionCreator = actionCreatorFactory('OrderLifetimeRule');

  export const reload = actionCreator('RELOAD');
  export const loadList = actionCreator.async<void, IOrderLifetimeRule[], IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IOrderLifetimeRule[], IRuleValidationResult[], IApiErrorParams>('UPDATE');
  export const validate = actionCreator.async<IOrderLifetimeRule[], IRuleValidationResult[], IApiErrorParams>('VALIDATE');
  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
